/**
 * Screens that fill the window instead of growing past it.
 *
 * Suhbatlar is three panes side by side: the list and the thread each scroll on their own,
 * and the page itself must not scroll, or reading an old message drags the list and the
 * composer off screen with it. The shell gives these routes exactly the window's height and
 * leaves the scrolling to the panes. Only from `lg`, where the panes sit side by side: on a
 * phone the filters take half the screen, and a locked thread would be a sliver under them.
 * Every other screen keeps the ordinary page scroll.
 */
const LOCKED_PATHS: readonly string[] = ["/inbox"];

export function locksViewport(pathname: string): boolean {
  return LOCKED_PATHS.includes(pathname);
}
